/**
 * MaxMart Smart Recommendations
 * 1. Sidebar: "Spesso acquistati insieme" (co-purchase data, layout lista verticale)
 * 2. Sotto il prodotto: "Potrebbe piacerti anche" (carousel orizzontale con frecce)
 */
(function() {
  'use strict';

  const VPS_API = 'https://api.maxmart.it/copurchase';

  // Inietta stili per la sezione "Spesso acquistati insieme" (posizionata a destra, sotto le info prodotto)
  (function() {
    var s = document.createElement('style');
    s.textContent = `
      .mm-bought-together {
        margin-top: 24px;
        padding: 20px;
        border: 1px solid #e8e8e8
        border-radius: 8px;
        background: #fafafa;
      }
      .mm-bought-together__title {
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 16px 0;
        color: #1a1a1a;
      }
      .mm-bought-together__list {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .mm-side-card {
        display: flex;
        align-items: center;
        gap: 12px;
        text-decoration: none;
        color: inherit;
        padding: 8px;
        border-radius: 6px;
        background: #fff;
        border: 1px solid #eee;
        transition: box-shadow 0.2s;
      }
      .mm-side-card:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      }
      .mm-side-card__link {
        display: flex;
        align-items: center;
        gap: 12px;
        text-decoration: none;
        color: inherit;
        width: 100%;
      }
      .mm-side-card__image-wrap {
        width: 60px;
        height: 60px;
        flex-shrink: 0;
        border-radius: 4px;
        overflow: hidden;
        background: #fafafa;
      }
      .mm-side-card__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .mm-side-card__info {
        flex: 1;
        min-width: 0;
      }
      .mm-side-card__vendor {
        display: block;
        font-size: 11px;
        color: #888;
        text-transform: uppercase;
        letter-spacing: 0.3px;
      }
      .mm-side-card__title {
        display: block;
        font-size: 13px;
        font-weight: 500;
        color: #333;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .mm-side-card__price {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #e67e22;
        margin-top: 2px;
      }
      @media (max-width: 749px) {
        .mm-bought-together {
          margin-top: 20px;
          padding: 16px;
        }
      }
    `;
    document.head.appendChild(s);
  })();

  // =============================================
  // CAROUSEL - per la sezione "Potrebbe piacerti anche"
  // =============================================
  class MMCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.mm-carousel__track');
      this.prevBtn = container.querySelector('.mm-carousel__prev');
      this.nextBtn = container.querySelector('.mm-carousel__next');
      this.scrollAmount = 0;
      this.init();
    }

    init() {
      if (!this.track) return;
      this.updateScrollAmount();
      window.addEventListener('resize', () => this.updateScrollAmount());

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.updateButtons());

      // Touch: let native scroll handle it (smoother), just update buttons on end
      this.track.addEventListener('touchend', () => { this.updateButtons(); }, { passive: true });
      this.track.addEventListener('scroll', () => { this.updateButtons(); }, { passive: true });

      // Mouse drag
      let isDragging = false;
      this.track.addEventListener('mousedown', (e) => {
        isDragging = true; startX = e.pageX; scrollLeft = this.track.scrollLeft;
        this.track.style.cursor = 'grabbing';
      });
      this.track.addEventListener('mousemove', (e) => {
        if (!isDragging) return; e.preventDefault();
        this.track.scrollLeft = scrollLeft + (startX - e.pageX) * 1.5;
      });
      this.track.addEventListener('mouseup', () => {
        isDragging = false; this.track.style.cursor = ''; this.updateButtons();
      });
      this.track.addEventListener('mouseleave', () => {
        isDragging = false; this.track.style.cursor = '';
      });

      setTimeout(() => this.updateButtons(), 100);
    }

    updateScrollAmount() {
      const card = this.track.querySelector('.mm-rec-card');
      if (card) {
        const gap = parseInt(getComputedStyle(this.track).gap) || 16;
        this.scrollAmount = card.offsetWidth + gap;
      } else {
        this.scrollAmount = 280;
      }
    }

    scroll(direction) {
      this.track.scrollBy({ left: this.scrollAmount * 2 * direction, behavior: 'smooth' });
      setTimeout(() => this.updateButtons(), 350);
    }

    updateButtons() {
      if (!this.track) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      if (this.prevBtn) this.prevBtn.style.display = scrollLeft > 5 ? 'flex' : 'none';
      if (this.nextBtn) this.nextBtn.style.display = (scrollLeft + clientWidth < scrollWidth - 5) ? 'flex' : 'none';
    }
  }

  // =============================================
  // UTILITY
  // =============================================
  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return price;
    return '€' + num.toFixed(2).replace('.', ',');
  }

  function escapeHtml(text) {
    const d = document.createElement('div');
    d.textContent = text;
    return d.innerHTML;
  }

  // =============================================
  // CARD BUILDERS
  // =============================================

  // Card per il CAROUSEL (sotto il prodotto)
  function buildCarouselCard(product) {
    const handle = product.handle || '';
    const url = handle.startsWith('/') ? handle : '/products/' + handle;
    const title = product.title || 'Prodotto';
    const price = product.price || '0.00';
    const comparePrice = product.compareAtPrice || product.compare_at_price || '';
    const image = product.image || product.featured_image || '';
    const vendor = product.vendor || '';

    const formattedPrice = formatPrice(price);
    const formattedCompare = comparePrice ? formatPrice(comparePrice) : '';
    const hasDiscount = formattedCompare && parseFloat(comparePrice) > parseFloat(price);

    const imgSrc = image ? image.replace(/\.([a-z]+)\?/, '_400x.$1?') : '';

    return `
      <div class="mm-rec-card">
        <a href="${url}" class="mm-rec-card__link">
          <div class="mm-rec-card__image-wrap">
            ${imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(title) + '" loading="lazy" class="mm-rec-card__image">' : '<div class="mm-rec-card__image-placeholder"></div>'}
            ${hasDiscount ? '<span class="mm-rec-card__badge">Offerta</span>' : ''}
          </div>
          <div class="mm-rec-card__info">
            ${vendor ? '<span class="mm-rec-card__vendor">' + escapeHtml(vendor) + '</span>' : ''}
            <h3 class="mm-rec-card__title">${escapeHtml(title)}</h3>
            <div class="mm-rec-card__price">
              <span class="mm-rec-card__price-current">${formattedPrice}</span>
              ${hasDiscount ? '<span class="mm-rec-card__price-compare">' + formattedCompare + '</span>' : ''}
            </div>
          </div>
        </a>
        <button class="mm-rec-card__add-btn" data-handle="${handle}" data-variant-id="${product.variants?.[0]?.id || product.id || ''}">
          Aggiungi al carrello
        </button>
      </div>
    `;
  }

  // Card per la SIDEBAR (lista verticale, più compatta)
  function buildSidebarCard(product) {
    const handle = product.handle || '';
    const url = handle.startsWith('/') ? handle : '/products/' + handle;
    const title = product.title || 'Prodotto';
    const price = product.price || '0.00';
    const image = product.image || product.featured_image || '';
    const vendor = product.vendor || '';

    const imgSrc = image ? image.replace(/\.([a-z]+)\?/, '_200x.$1?') : '';
    const formattedPrice = formatPrice(price);

    return `
      <div class="mm-side-card">
        <a href="${url}" class="mm-side-card__link">
          <div class="mm-side-card__image-wrap">
            ${imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(title) + '" loading="lazy" class="mm-side-card__image">' : ''}
          </div>
          <div class="mm-side-card__info">
            ${vendor ? '<span class="mm-side-card__vendor">' + escapeHtml(vendor) + '</span>' : ''}
            <span class="mm-side-card__title">${escapeHtml(title)}</span>
            <span class="mm-side-card__price">${formattedPrice}</span>
          </div>
        </a>
      </div>
    `;
  }

  // =============================================
  // AJAX ADD TO CART
  // =============================================
  function setupAddToCart(container) {
    container.querySelectorAll('.mm-rec-card__add-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        const handle = btn.dataset.handle;

        if (!variantId || variantId === 'undefined') {
          if (handle) window.location.href = '/products/' + handle;
          return;
        }

        btn.textContent = 'Aggiungendo...';
        btn.disabled = true;

        try {
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          });

          if (resp.ok) {
            btn.textContent = 'Aggiunto ✓';
            btn.classList.add('mm-rec-card__add-btn--success');

            // Update cart count
            try {
              const cartResp = await fetch('/cart.js');
              if (cartResp.ok) {
                const cart = await cartResp.json();
                document.querySelectorAll('.cart-count-bubble span, [data-cart-count]')
                  .forEach(el => el.textContent = cart.item_count);
              }
            } catch(e) {}

            setTimeout(() => {
              btn.textContent = 'Aggiungi al carrello';
              btn.classList.remove('mm-rec-card__add-btn--success');
              btn.disabled = false;
            }, 2000);
          } else {
            throw new Error('fail');
          }
        } catch (err) {
          btn.textContent = 'Vedi prodotto';
          btn.addEventListener('click', () => {
            if (handle) window.location.href = '/products/' + handle;
          }, { once: true });
          setTimeout(() => {
            btn.textContent = 'Aggiungi al carrello';
            btn.disabled = false;
          }, 2000);
        }
      });
    });
  }

  // =============================================
  // DATA FETCHING
  // =============================================
  async function fetchCoPurchaseRecs(productId, productTitle) {
    try {
      var url = VPS_API + '/api/recommendations/' + productId + '?limit=8&related=false';
      if (productTitle) url += '&title=' + encodeURIComponent(productTitle);
      console.log('[mm-rec] fetch ' + url);
      const resp = await fetch(url);
      if (!resp.ok) throw new Error('API HTTP ' + resp.status);
      const data = await resp.json();
      console.log('[mm-rec] response source=' + data.source + ' count=' + (data.boughtTogether?.length || 0));
      return data.boughtTogether || [];
    } catch (err) {
      console.error('[mm-rec] errore API copurchase:', err.message);
      return [];
    }
  }

  async function fetchShopifyRecs(productId, limit) {
    try {
      const resp = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit);
      if (!resp.ok) throw new Error('Shopify recs error');
      const data = await resp.json();
      return (data.products || []).map(p => ({
        id: p.id,
        handle: p.handle,
        title: p.title,
        image: p.featured_image,
        price: (p.price / 100).toFixed(2),
        compareAtPrice: p.compare_at_price ? (p.compare_at_price / 100).toFixed(2) : '',
        vendor: p.vendor,
        variants: p.variants
      }));
    } catch (err) {
      console.log('Shopify recommendations non disponibili:', err.message);
      return [];
    }
  }

  // =============================================
  // 1. "Spesso acquistati insieme" — posizionato a DESTRA, sotto le info prodotto
  // =============================================
  function formatPrice(p) {
    if (p === null || p === undefined || p === '') return '';
    const n = parseFloat(String(p).replace(',', '.'));
    if (isNaN(n)) return String(p);
    return n.toFixed(2).replace('.', ',');
  }

  function shopifyImageTransform(url, size) {
    if (!url || !size) return url || '';
    // Inserisce _SIZEx prima dell'estensione → 32466770.jpg?v=1 → 32466770_400x.jpg?v=1
    return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  // Inietta CSS del nuovo design (una volta sola)
  (function injectSidebarStyles() {
    if (document.getElementById('mm-sidebar-styles')) return;
    const s = document.createElement('style');
    s.id = 'mm-sidebar-styles';
    s.textContent = `
      .sidebar-products.side-box[data-mm-replaced="1"] {
        background: #fafafa;
        border-radius: 10px;
        padding: 0;
        overflow: hidden;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .box-heading {
        font-size: 14px;
        font-weight: 700;
        color: #fff;
        margin: 0;
        padding: 12px 14px;
        background: #1a2d4d;
        border-radius: 10px 10px 0 0;
        text-transform: none;
        letter-spacing: 0;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .box-content {
        list-style: none;
        margin: 0;
        padding: 10px 10px 4px;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card {
        list-style: none;
        margin-bottom: 8px;      max-width: none;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-inner {
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #eee;
        background: #fff;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-link {
        display: block;
        text-decoration: none;
        color: inherit;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-img {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        box-sizing: border-box;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-img img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-meta {
        padding: 4px 10px 0;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-title {
        font-size: 11px;
        font-weight: 500;
        color: #333;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-price {
        font-size: 13px;
        font-weight: 700;
        color: #e67e22;
        margin-top: 2px;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-card-cta {
        padding: 6px 10px 8px;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-add-btn {
        width: 100%;
        padding: 7px 0;
        border: none;
        border-radius: 6px;
        background: #FFB700;
        color: #000;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;
        font-family: inherit;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-add-btn:hover {
        background: #e6a500;
      }
      .sidebar-products.side-box[data-mm-replaced="1"] .mm-add-btn.added {
        background: #27ae60;
        color: #fff;
      }
      /* Margini minimi e simmetrici: sidebar riempie la colonna senza padding extra */
      @media (min-width: 750px) {
        .side-bar.mm-rec-attached {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
        .side-bar.mm-rec-attached .sidebar-products.side-box[data-mm-replaced="1"] {
          margin: 0;
          width: 100%;
        }
      }
      /* Animazione shimmer skeleton loader */
      @keyframes mmShimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
      /* FOUC fix: sidebar nascosta finché JS non ha inserito contenuto/skeleton */
      .sidebar-products.side-box:not(.mm-loaded) .box-content,
      .sidebar-products.side-box:not(.mm-loaded) .box-heading {
        visibility: hidden;
      }
      .sidebar-products.side-box.mm-loaded .box-content,
      .sidebar-products.side-box.mm-loaded .box-heading {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s ease;
      }
    `;
    document.head.appendChild(s);
  })();

  function getProductTitleRobust() {
    // 1. Shopify analytics meta (più affidabile)
    if (window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.name) {
      const n = String(window.ShopifyAnalytics.meta.product.variants[0].name).split(' - ')[0].trim();
      if (n) return n;
    }
    // 2. Meta tag og:title
    const og = document.querySelector('meta[property="og:title"]');
    if (og && og.content) return og.content.trim();
    // 3. JSON-LD
    for (const s of document.querySelectorAll('script[type="application/ld+json"]')) {
      try {
        const d = JSON.parse(s.textContent);
        if (d?.['@type'] === 'Product' && d.name) return String(d.name).trim();
        if (Array.isArray(d) && d[0]?.name) return String(d[0].name).trim();
      } catch {}
    }
    // 4. Heading dentro la sezione prodotto principale
    const sel = [
      '.product__title h1', '.product__title', 'h1.product-title', 'h1.product__title',
      '.product-single__title', '.breadcrumb_title', 'main h1', 'h1'
    ];
    for (const s of sel) {
      const el = document.querySelector(s);
      const t = el?.textContent?.trim();
      if (t && t.length > 2 && !/maxmart/i.test(t)) return t;
    }
    return '';
  }

  /**
   * Card con stili 100% inline (battono qualsiasi CSS del tema).
   */
  function buildNovitaCard(p) {
    const handle = p.handle || '';
    const url = handle ? '/products/' + handle : (p.url || '#');
    const img = shopifyImageTransform(p.image || p.featured_image || '', 400);
    const title = p.title || '';
    const price = formatPrice(p.price);
    const variantId = (Array.isArray(p.variants) && p.variants[0] && p.variants[0].id) ? String(p.variants[0].id) : '';
    return '<li class="mm-card" style="list-style:none;margin:0 0 8px 0;padding:0;">' +
      '<div style="border-radius:8px;overflow:hidden;border:1px solid #eee;background:#fff;">' +
        '<a href="' + url + '" style="display:block;text-decoration:none;color:inherit;">' +
          '<div style="width:100%;height:100px;display:flex;align-items:center;justify-content:center;padding:8px;box-sizing:border-box;">' +
            (img ? '<img src="' + img + '" alt="' + escapeHtml(title) + '" loading="lazy" style="max-width:100%;max-height:100%;object-fit:contain;">' : '') +
          '</div>' +
          '<div style="padding:4px 10px 0;">' +
            '<div style="font-size:11px;font-weight:500;color:#333;line-height:1.3;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;" title="' + escapeHtml(title) + '">' + escapeHtml(title) + '</div>' +
            (price ? '<div style="font-size:13px;font-weight:700;color:#e67e22;margin-top:2px;">€' + price + '</div>' : '') +
          '</div>' +
        '</a>' +
        '<div style="padding:6px 10px 8px;">' +
          '<button type="button" class="mm-add-btn" ' +
            'data-handle="' + escapeHtml(handle) + '" ' +
            'data-variant-id="' + variantId + '" ' +
            'onclick="window.mmAddToCartSidebar(this)" ' +
            'style="width:100%;padding:7px 0;border:none;border-radius:6px;background:#FFB700;color:#000;font-size:11px;font-weight:600;cursor:pointer;transition:background 0.2s,color 0.2s;font-family:inherit;">' +
            'Aggiungi al carrello' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  /**
   * Skeleton loader: 3 card shimmer mostrate SUBITO mentre l'API risponde.
   */
  function buildSkeletonCard() {
    const sh = 'background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%);background-size:200% 100%;animation:mmShimmer 1.5s infinite;';
    return '<li style="list-style:none;margin:0 0 8px 0;padding:0;">' +
      '<div style="border-radius:8px;overflow:hidden;border:1px solid #eee;background:#fff;">' +
        '<div style="width:100%;height:100px;' + sh + '"></div>' +
        '<div style="padding:8px 10px 10px;">' +
          '<div style="height:11px;width:80%;border-radius:4px;margin-bottom:6px;' + sh + '"></div>' +
          '<div style="height:13px;width:40%;border-radius:4px;margin-bottom:8px;' + sh + '"></div>' +
          '<div style="height:28px;width:100%;border-radius:6px;' + sh + '"></div>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function applyContainerStyles(sidebar, heading, content) {
    sidebar.style.cssText = 'background:#fafafa;border-radius:10px;padding:0;overflow:hidden;';
    if (heading) {
      heading.textContent = 'Spesso acquistati insieme';
      heading.style.cssText = 'font-size:14px;font-weight:700;color:#fff;margin:0;padding:12px 14px;background:#1a2d4d;border-radius:10px 10px 0 0;text-transform:none;letter-spacing:0;';
    }
    if (content) {
      content.style.cssText = 'list-style:none;margin:0;padding:8px;';
    }
  }

  /**
   * Add-to-cart globale: usa variant_id se disponibile, altrimenti lo recupera via /products/{handle}.json.
   */
  window.mmAddToCartSidebar = async function(btn) {
    if (!btn || btn.disabled) return;
    const original = btn.textContent;
    btn.disabled = true;
    let variantId = btn.dataset.variantId;
    const handle = btn.dataset.handle;

    try {
      if (!variantId && handle) {
        const r = await fetch('/products/' + encodeURIComponent(handle) + '.json');
        if (r.ok) {
          const d = await r.json();
          variantId = d.product?.variants?.[0]?.id;
        }
      }
      if (!variantId) throw new Error('variant_id non disponibile');

      const cartResp = await fetch('/cart/add.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });
      if (!cartResp.ok) throw new Error('add-to-cart HTTP ' + cartResp.status);

      btn.textContent = 'Aggiunto ✓';
      btn.classList.add('added');

      // Aggiorna contatore carrello header (se presente nel tema)
      try {
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch {}

      setTimeout(() => {
        btn.textContent = original;
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2000);
    } catch (err) {
      console.error('[mm-rec] add-to-cart errore:', err.message);
      btn.textContent = 'Errore';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  };

  async function initSidebar(productId) {
    const sidebar = document.querySelector('.sidebar-products.side-box');
    if (!sidebar) {
      console.log('[mm-rec] Sidebar .sidebar-products.side-box non presente — niente da fare');
      return;
    }

    const pageTitle = getProductTitleRobust();
    console.log('[mm-rec] initSidebar productId=' + productId + ' title="' + pageTitle + '"');

    // STEP 0 — IMMEDIATO: applica stili contenitore + skeleton loader (così niente flash di "Novità")
    const heading = sidebar.querySelector('.box-heading');
    let content = sidebar.querySelector('.box-content') || sidebar.querySelector('ul');
    if (!content) {
      sidebar.insertAdjacentHTML('beforeend', '<ul class="box-content"></ul>');
      content = sidebar.querySelector('.box-content');
    }
    applyContainerStyles(sidebar, heading, content);
    content.innerHTML = buildSkeletonCard() + buildSkeletonCard() + buildSkeletonCard();
    sidebar.setAttribute('data-mm-replaced', '1');
    sidebar.classList.add('mm-loaded');
    const parentCol = sidebar.closest('.side-bar');
    if (parentCol) parentCol.classList.add('mm-rec-attached');

    // STEP 1: prova VPS API (AI complementari)
    let products = await fetchCoPurchaseRecs(productId, pageTitle);
    console.log('[mm-rec] VPS API → ' + products.length + ' prodotti');

    // STEP 2: fallback Shopify native recommendations
    if (products.length === 0) {
      console.log('[mm-rec] Provo fallback Shopify native…');
      products = await fetchShopifyRecs(productId, 3);
      console.log('[mm-rec] Shopify native → ' + products.length + ' prodotti');
    }

    // STEP 3: se ancora nulla → ripristina contenuto originale di "Novità"
    if (products.length === 0) {
      console.log('[mm-rec] Nessun risultato — ripristino sidebar Novità originale');
      // Reset stili inline sul sidebar/heading/content (rimuove cssText custom)
      sidebar.style.cssText = '';
      if (heading) { heading.style.cssText = ''; heading.textContent = 'Novità'; }
      if (content) content.style.cssText = '';
      sidebar.removeAttribute('data-mm-replaced');
      if (parentCol) parentCol.classList.remove('mm-rec-attached');
      // Lascia sidebar visibile (mm-loaded resta) — ma ATTENZIONE: se theme.liquid ha CSS che nasconde,
      // la classe mm-loaded la rende visibile lo stesso.
      // Ricarica i prodotti originali "Novità" non è banale (sono renderizzati server-side).
      // Tradeoff: l'unica via pulita è lasciare il contenuto originale che verrebbe servito senza JS.
      // Per essere robusti, ricarichiamo la pagina nella vecchia modalità: NON tocchiamo il content qui.
      // Ma noi abbiamo già messo skeleton... torniamo a "Novità" placeholder semplice:
      content.innerHTML = '<li style="list-style:none;padding:16px 14px;color:#888;font-size:13px;">Nessun suggerimento disponibile</li>';
      return;
    }

    // STEP 4: render finale
    const cardsHTML = products.slice(0, 3).map(buildNovitaCard).join('');
    content.innerHTML = cardsHTML;
    // Riapplica stili (potrebbero essere stati sovrascritti)
    applyContainerStyles(sidebar, heading, content);

    // Nascondi eventuali vecchi box .mm-bought-together rimasti
    document.querySelectorAll('.mm-bought-together, [data-mm-bought-together]').forEach(el => {
      el.style.display = 'none';
    });

    console.log('[mm-rec] ✓ Sidebar sostituita: "Spesso acquistati insieme" (' + Math.min(products.length, 3) + ' prodotti)');
  }

  // =============================================
  // 2. CAROUSEL: "Potrebbe piacerti anche"
  // =============================================
  async function initCarousel(productId) {
    const container = document.querySelector('.product-recommendations, [data-product-recommendations]');
    if (!container) return;

    const shopifyRecs = await fetchShopifyRecs(productId, 12);

    if (shopifyRecs.length === 0) {
      // Trasforma griglia esistente in carousel
      transformExistingGrid(container);
      return;
    }

    const cards = shopifyRecs.map(p => buildCarouselCard(p)).join('');

    const html = `
      <div class="mm-recommendations-wrapper">
        <div class="mm-rec-section" id="mm-you-may-like">
          <div class="mm-rec-section__header">
            <h2 class="mm-rec-section__title">Potrebbe piacerti anche</h2>
          </div>
          <div class="mm-carousel">
            <button class="mm-carousel__prev" aria-label="Precedente" style="display:none">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <div class="mm-carousel__track">
              ${cards}
            </div>
            <button class="mm-carousel__next" aria-label="Successivo">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;

    const parentSection = container.closest('.shopify-section') || container;
    parentSection.innerHTML = html;

    const wrapper = parentSection.querySelector('.mm-recommendations-wrapper');
    wrapper.querySelectorAll('.mm-carousel').forEach(el => new MMCarousel(el));
    setupAddToCart(wrapper);
  }

  // Fallback: trasforma griglia esistente in carousel
  function transformExistingGrid(container) {
    const grid = container.querySelector('.product-grid, .grid');
    if (!grid) return;

    const heading = container.querySelector('h2');
    const headingText = heading ? heading.textContent.trim() : 'Potrebbe piacerti anche';
    const cards = grid.querySelectorAll('.grid__item');
    if (cards.length === 0) return;

    const parentSection = container.closest('.shopify-section') || container;

    parentSection.innerHTML = `
      <div class="mm-recommendations-wrapper">
        <div class="mm-rec-section" id="mm-you-may-like">
          <div class="mm-rec-section__header">
            <h2 class="mm-rec-section__title">${headingText}</h2>
          </div>
          <div class="mm-carousel">
            <button class="mm-carousel__prev" aria-label="Precedente" style="display:none">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <div class="mm-carousel__track"></div>
            <button class="mm-carousel__next" aria-label="Successivo">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;

    const track = parentSection.querySelector('.mm-carousel__track');
    cards.forEach(card => {
      const wrapper = document.createElement('div');
      wrapper.className = 'mm-rec-card mm-rec-card--native';
      wrapper.innerHTML = card.innerHTML;
      track.appendChild(wrapper);
    });

    parentSection.querySelectorAll('.mm-carousel').forEach(el => new MMCarousel(el));
  }

  // =============================================
  // MAIN INIT
  // =============================================
  async function init() {
    // Trova il product ID
    const recContainer = document.querySelector('.product-recommendations, [data-product-recommendations]');
    let productId = null;

    if (recContainer) {
      productId = recContainer.dataset.productId
        || (recContainer.getAttribute('data-url') || '').match(/product_id=(\d+)/)?.[1];
    }

    if (!productId) {
      const metaEl = document.querySelector('meta[property="og:url"]');
      if (metaEl) {
        const url = metaEl.content;
        // Try to get product ID from page source
        const scripts = document.querySelectorAll('script[type="application/json"]');
        for (const s of scripts) {
          try {
            const data = JSON.parse(s.textContent);
            if (data.product && data.product.id) {
              productId = String(data.product.id);
              break;
            }
          } catch(e) {}
        }
      }
    }

    if (!productId) {
      // Try from Shopify's ShopifyAnalytics
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        productId = String(window.ShopifyAnalytics.meta.product.id);
      }
    }

    if (!productId) {
      console.warn('[mm-rec] product ID NON trovato — niente sidebar');
      if (recContainer) transformExistingGrid(recContainer);
      return;
    }
    console.log('[mm-rec] init() productId=' + productId);

    // Lancia entrambe le sezioni in parallelo
    await Promise.all([
      initSidebar(productId),
      initCarousel(productId)
    ]);
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0));
  } else {
    setTimeout(init, 0);
  }
})();
